import { RootState } from 'handlers';

export const getLoanGoal = ({ yourGoal }: RootState) => yourGoal;
